{
  "buttonLabel": "Afficher les suggestions",
  "countAnnouncement": "{optionCount, plural, one {# option} other {# options}} disponible(s).",
  "focusAnnouncement": "{isGroupChange, select, true {Groupe {groupTitle} rejoint, avec {groupCount, plural, one {# option} other {# options}}. } other {}}{optionText}{isSelected, select, true {, sélectionné(s)} other {}}",
  "listboxLabel": "Suggestions",
  "selectedAnnouncement": "{optionText}, sélectionné"
}
